import { numberFormatFor } from '../money/format.ts'
import type { Locale } from './locale.ts'

/** A whole count or distance (km, events) with the locale's group separator; never a money figure. */
export function formatCount(value: number, locale: Locale): string {
  const { groupSeparator } = numberFormatFor(locale)
  const digits = Math.abs(Math.trunc(value)).toString()
  const grouped = digits.replace(/\B(?=(\d{3})+$)/g, groupSeparator)
  return value < 0 ? `-${grouped}` : grouped
}
